import { IconButton } from '@material-ui/core';
import { OpenInNew } from '@material-ui/icons';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import useRole from '../hooks/useRole';
import { getExternalDetailLink } from '../modules/external-detail-link';
import { MarketingChannel, SourceType } from '../modules/generated/api';
import { getLabel, sources } from '../modules/labels';
import UserRole from '../types/UserRoles';

import ActionTooltip from './ActionTooltip';

type ActionExternalDetailLinkProps = {
  source?: SourceType;
  carId?: string;
  size?: 'small' | 'medium';
  offerId?: string;
  marketingChannel?: MarketingChannel[];
};

const ActionExternalDetailLink = ({
  source,
  carId,
  size = 'small',
  offerId,
  marketingChannel,
}: ActionExternalDetailLinkProps) => {
  const { hasRole } = useRole();
  const { t } = useTranslation();
  const link = getExternalDetailLink(source, carId, offerId, marketingChannel);

  return hasRole(UserRole.ADMIN) || source === SourceType.AudiUcp ? (
    <ActionTooltip title={`${t('carsTable.directLink')} ${getLabel(sources, source as string)}`} disabled={!link}>
      <IconButton disabled={!link} size={size} href={link || ''} rel="noreferrer" target="_blank">
        <OpenInNew />
      </IconButton>
    </ActionTooltip>
  ) : null;
};

export default memo(ActionExternalDetailLink);
